import { Card } from './components/Card';
import { Button } from './components/Button';
import { Modal } from './components/Modal';
import { Separator } from './components/Separator';
import { SwitchRow } from './components/SwitchRow';
import { AddCard } from './components/AddCard';
import { Input } from './forms/Input';
import { Select } from './forms/Select';
import { Textarea } from './forms/Textarea';
import { SelectableTile, TileGroup } from './forms/SelectableTile';
import { Pager } from './navigation/Pager';
import { EntityBreakdown } from './feedback/EntityBreakdown';

// Temporary stabilization shim:
// Keep local import paths (`src/design-system`) while routing primitives directly to HeroUI.
// This lets us isolate whether wrapper-layer behavior introduced in 3db9871 is causing the OOM.
export {
  Accordion,
  Avatar,
  Breadcrumbs,
  BreadcrumbsItem,
  Chip,
  ComboBox,
  Description,
  Dropdown,
  FieldError,
  Fieldset,
  Form,
  Kbd,
  Label,
  Link,
  ListBox,
  Popover,
  ProgressBar,
  ProgressCircle,
  Radio,
  RadioGroup,
  SearchField,
  Skeleton,
  Switch,
  Tabs,
  TextField,
  ToastProvider,
  Tooltip,
  toast
} from '@heroui/react';
export { useTheme } from '@heroui/use-theme';
export {
  useBrand,
  applyBrand,
  persistBrand,
  getStoredBrand,
  THEME_BRANDS,
  DEFAULT_BRAND,
  BRAND_LABELS,
  type ThemeBrand
} from './brand';
export type { Key } from '@heroui/react';

// Keep local design-system-only components/aliases.
export { Badge } from './feedback/Badge';
export { Code } from './feedback/Code';
export type { CodeProps } from './feedback/Code';
export { default as FavoriteButton } from './components/FavoriteButton';
export { EmptyState } from './feedback/EmptyState';
export { FormField } from './forms/FormField';
export { PageHeader } from './layout/PageHeader';
export { PageShell } from './layout/PageShell';
export { SectionHeader } from './layout/SectionHeader';
export { Spinner } from './feedback/Spinner';
export { Card };
export { Button };
export { Modal };
export { SwitchRow };
export {
  ModalCloseButton,
  StandardModalHeader,
  ModalFormFooter,
  ModalConfirmFooter,
  ModalSplitFooter,
  ModalPrimaryFooter
} from './components/ModalShell';
export type {
  ModalActionConfig,
  ModalCloseButtonProps,
  StandardModalHeaderProps,
  ModalFormFooterProps,
  ModalConfirmFooterProps,
  ModalSplitFooterProps,
  ModalPrimaryFooterProps
} from './components/ModalShell';
export { Separator };
export { Input };
export { Select };
export { Textarea };
export { AddCard };
export type { AddCardProps } from './components/AddCard';
export { SelectableTile, TileGroup };
export { Pager };
export type { PagerProps } from './navigation/Pager';
export { EntityBreakdown };
export type { EntityBreakdownProps, BreakdownItem } from './feedback/EntityBreakdown';

// Back-compat aliases used across the codebase.
export const CardHeader = Card.Header;
export const CardFooter = Card.Footer;
export const TextArea = Textarea;
